import {
  AfterViewInit,
  Component,
  Input,
  ViewEncapsulation,
  Renderer2,
  ElementRef,
  AfterContentChecked,
} from '@angular/core';
import { NgIf } from '@angular/common';
import { MarkedPipe } from '../../pipes/marked.pipe';

@Component({
    selector: 'app-render-markdown',
    templateUrl: './render-markdown.component.html',
    styleUrls: ['./render-markdown.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgIf, MarkedPipe],
})
export class RenderMarkdownComponent
  implements AfterViewInit, AfterContentChecked
{
  @Input() content: string | undefined;

  private parentContentAttribute: string | null = null;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit() {
    // Step 1: Get the parent element
    const { parentElement }: { parentElement: HTMLElement } =
      this.el.nativeElement;

    this.parentContentAttribute = this.getNgContentAttribute(parentElement);

    this.applyStyling();
  }

  ngAfterContentChecked() {
    this.applyStyling();
  }

  // Helper function to find _ngcontent-* attribute dynamically
  private getNgContentAttribute(element: HTMLElement): string | null {
    const { attributes } = element;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < attributes.length; i++) {
      const attr = attributes[i];
      if (attr.name.startsWith('_ngcontent-')) {
        return attr.name;
      }
    }
    return null;
  }

  public applyStyling() {
    if (this.parentContentAttribute) {
      const contentContainer =
        this.el.nativeElement.querySelector('.markdown-content');

      if (!contentContainer) return;
      const elements = contentContainer.querySelectorAll('*');
      elements.forEach((element: HTMLElement) => {
        this.renderer.setAttribute(element, this.parentContentAttribute!, '');
      });
    }
  }
}
